import { deleteSdkKeyByKey } from '@gonfalon/openapi/operations/deleteSdkKeyByKey';
import { getProjectSdkKeys } from '@gonfalon/openapi/operations/getProjectSdkKeys';
import { patchSdkKeyByKey } from '@gonfalon/openapi/operations/patchSdkKeyByKey';
import { postSdkKey } from '@gonfalon/openapi/operations/postSdkKey';
import { putSdkKeyViews } from '@gonfalon/openapi/operations/putSdkKeyViews';
import { getQueryClient } from '@gonfalon/react-query-client/getQueryClient';

import { createInfiniteQueryOptions } from '../internal/createInfiniteQueryOptions';
import { createMutationHook } from '../internal/createMutationHook';
import { createQueryOptions } from '../internal/createQueryOptions';

export const getProjectSdkKeysQuery = createQueryOptions(getProjectSdkKeys);

/**
 * Infinite variant of {@link getProjectSdkKeysQuery}, used for the offset-paginated "expired keys"
 * sections (REL-14298). The SDK keys response has no `_links.next`, so consumers must override
 * `getNextPageParam` with offset/`totalCount` math (see `ManageSdkKeys`).
 */
export const getInfiniteProjectSdkKeysQuery = createInfiniteQueryOptions(getProjectSdkKeys);
export const useCreateSdkKey = createMutationHook(postSdkKey, {
  onSuccess: async () => {
    const queryClient = getQueryClient();
    await queryClient.invalidateQueries({ queryKey: getProjectSdkKeysQuery.partialQueryKey() });
  },
});
export const useUpdateSdkKey = createMutationHook(patchSdkKeyByKey, {
  onSuccess: async () => {
    const queryClient = getQueryClient();
    await queryClient.invalidateQueries({ queryKey: getProjectSdkKeysQuery.partialQueryKey() });
  },
});
export const useDeleteSdkKey = createMutationHook(deleteSdkKeyByKey, {
  onSuccess: async () => {
    const queryClient = getQueryClient();
    await queryClient.invalidateQueries({ queryKey: getProjectSdkKeysQuery.partialQueryKey() });
  },
});

/**
 * Payload Filtering v2: mutation for `PUT /sdk-keys/{key}/views`. Replaces the full set of views
 * associated with an SDK key — `body.viewKeys` is the complete target list, and an empty array
 * removes all views.
 */
export const useUpdateSdkKeyViews = createMutationHook(putSdkKeyViews, {
  onSuccess: async () => {
    const queryClient = getQueryClient();
    await queryClient.invalidateQueries({ queryKey: getProjectSdkKeysQuery.partialQueryKey() });
  },
});
